import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import TimeHelper from '../../../../../utils/time';
import { ShippmentQuery } from '../../../../../services/query';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useTranslation } from 'react-i18next';
import { UCSH } from '../userOrderProductDetails.classes';

function UserCargoStatusHistory({ shipment }: any) {
    const { t } = useTranslation();
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let params = { shippingListId: shipment.shippingListId };
        ShippmentQuery.GetShippingListStatusHistory(params)
            .then((res: any) => {
                if (res?.shippingListStatusHistoryModel) {
                    setData(res.shippingListStatusHistoryModel);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <div
                className={UCSH.loadingWrap}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                }}
            >
                <CircularProgress className={UCSH.loadingInner} size={80} />
            </div>
        );
    }

    return (
        <div className={UCSH.root} style={{ padding: '2rem' }}>
            {data && data.length > 0 ? (
                <>
                    <Table className={UCSH.table}>
                        <TableHead>
                            <TableRow className={UCSH.headRow}>
                                <TableCell className={UCSH.headCellDate}>{t('orderDetail.date')}</TableCell>
                                <TableCell className={UCSH.headCellUser}>{t('orderDetail.user')}</TableCell>
                                <TableCell className={UCSH.headCellUserType}>{t('orderDetail.userType')}</TableCell>
                                <TableCell className={UCSH.headCellStatus}>{t('general.status')}</TableCell>
                                <TableCell className={UCSH.headCellDescription}>
                                    {t('orderDetail.description')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row: any, index: number) => (
                                <TableRow className={UCSH.bodyRow} key={index}>
                                    <TableCell className={UCSH.bodyCellDate}>
                                        {TimeHelper.formatDateHour(row.createdOn)}
                                    </TableCell>
                                    <TableCell className={UCSH.bodyCellUser}>{row.userName}</TableCell>
                                    <TableCell className={UCSH.bodyCellUserType}>
                                        {row.isOperator ? <p style={{ color: 'blue' }}>Backoffice</p> : <p>Web</p>}
                                    </TableCell>
                                    <TableCell className={UCSH.bodyCellStatus}>
                                        {row.backendStatusDescription}
                                    </TableCell>
                                    <TableCell className={UCSH.bodyCellDescription}>{row.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow className={UCSH.footerRow}>
                                <TableCell colSpan={4} />
                                <TableCell className={UCSH.footerTotal} align="right">
                                    {t('orderDetail.totalRecordsCount')}: {data.length}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </>
            ) : (
                <div
                    className={UCSH.emptyWrap}
                    style={{
                        color: '#666463',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '2rem',
                    }}
                >
                    <ContactSupportIcon className={UCSH.emptyIcon} style={{ width: '40px', height: 'auto' }} />
                    <h2 className={UCSH.emptyTitle} style={{ marginLeft: '2rem' }}>
                        {t('orderDetail.statuInfoNotFound')}
                    </h2>
                </div>
            )}
        </div>
    );
}

export default UserCargoStatusHistory;
